import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { isRoleAllowed } from "../auth/roles";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, roleType } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to={`/login?return=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  }

  if (!isRoleAllowed(roleType, allowedRoles)) {
    const defaultPath = "/home";
    return <Navigate to={defaultPath} replace />;
  }

  return children;
};

export default ProtectedRoute;


